import { useTheme, StyleSystemProps } from '@withjoy/joykit';
import { animationTransition } from '@shared/utils/animationTransition';

export const useInputErrorStyles = (): StyleSystemProps => {
  const theme = useTheme();
  return {
    _after: {
      background: 'none',
      borderRadius: 2,
      boxShadow: `0px 0 0px 1px ${theme.colors.negative6}`,
      display: 'block',
      content: '" "',
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      transition: animationTransition('box-shadow'),
      width: '100%',
    },
    _hover: {
      _after: {
        boxShadow: `0px 0 0px 1px ${theme.colors.negative5}`,
      },
    },
    _focusWithin: {
      _after: {
        boxShadow: `0px 0 0px 2px ${theme.colors.negative6}`,
      },
    },
  };
};
